<template>
  <v-container fluid>
    <div>
      <h3 class="headline">{{ $t('Order Summary') }}</h3>

      <div v-if="loading" class="text-xs-center" style="min-height: 400px">
        <v-layout justify-center align-center row style="height: 400px">
          <v-flex>
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </div>
      <template v-else>
        <div class="mb-2">
          <div style="overflow-x: auto; white-space: nowrap">
            <v-btn
              class="ma-0 mr-1 mb-1"
              depressed
              :outline="currentFilter != 'today'"
              :color="currentFilter == 'today' ? 'primary' : 'grey'"
              small
              @click="changeDate('today')"
              >{{ $t('today') }}</v-btn
            >
            <v-btn
              v-if="selectedBot.theme !== 'nvbb'"
              class="ma-0 mr-1 mb-1"
              depressed
              :outline="currentFilter != 'last_7_days'"
              :color="currentFilter == 'last_7_days' ? 'primary' : 'grey'"
              small
              @click="changeDate('last_7_days')"
              >{{ $t('last {day} days', { day: 7 }) }}</v-btn
            >

            <v-btn
              v-if="selectedBot.theme !== 'nvbb'"
              class="ma-0 mr-1 mb-1"
              depressed
              :outline="currentFilter != 'last_15_days'"
              :color="currentFilter == 'last_15_days' ? 'primary' : 'grey'"
              small
              @click="changeDate('last_15_days')"
              >{{ $t('last {day} days', { day: 15 }) }}</v-btn
            >
            <v-btn
              class="ma-0 mr-1 mb-1"
              depressed
              :outline="currentFilter != 'this_month'"
              :color="currentFilter == 'this_month' ? 'primary' : 'grey'"
              small
              @click="changeDate('this_month')"
              >{{ $t('this month') }}</v-btn
            >
            <v-btn
              class="ma-0 mr-1 mb-1"
              depressed
              :outline="currentFilter != 'this_year'"
              :color="currentFilter == 'this_year' ? 'primary' : 'grey'"
              small
              @click="changeDate('this_year')"
              >{{ $t('this year') }}</v-btn
            >
            <v-btn
              v-if="selectedBot.theme !== 'nvbb'"
              class="ma-0 mr-1 mb-1"
              depressed
              :outline="currentFilter != 'last_month'"
              :color="currentFilter == 'last_month' ? 'primary' : 'grey'"
              small
              @click="changeDate('last_month')"
              >{{ $t('last 30 days') }}</v-btn
            >
            <v-btn
              v-if="selectedBot.theme !== 'nvbb'"
              class="ma-0 mr-1 mb-1"
              depressed
              :outline="currentFilter != 'last_365_day'"
              :color="currentFilter == 'last_365_day' ? 'primary' : 'grey'"
              small
              @click="changeDate('last_365_day')"
              >{{ $t('last 365 days') }}</v-btn
            >
            <v-btn
              class="ma-0 mr-1 mb-1"
              depressed
              :outline="currentFilter != 'custom_date'"
              :color="currentFilter == 'custom_date' ? 'primary' : 'grey'"
              small
              @click="changeDate('custom_date')"
              >{{ $t('Custom Date') }}</v-btn
            >
          </div>
          <v-layout
            v-if="currentFilter == 'custom_date' || currentFilter == 'custom_time'"
            wrap
            class="mt-2"
          >
            <v-flex xs12 sm6>
              <span class="order_summary_datepicker">{{ $t('from') }}:</span>
              <v-layout wrap row>
                <v-flex xs8 class="form-control">
                  <datepicker
                    v-model="selectedDate.start"
                    style="margin-bottom: 10px"
                    @selected="onSelectedStartDate"
                  ></datepicker>
                </v-flex>
                <v-flex xs4 class="form-control">
                  <v-dialog
                    ref="starttime"
                    v-model="showStartTimeDialog"
                    :return-value.sync="starttime"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template #activator="{ on }">
                      <div class="pl-2 pr-2">
                        <input
                          v-model="starttime"
                          type="text"
                          readonly
                          placeholder="00:00"
                          v-on="on"
                        />
                      </div>
                    </template>
                    <v-time-picker v-if="showStartTimeDialog" v-model="starttime" full-width>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="showStartTimeDialog = false">
                        {{ $t('cancel') }}
                      </v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="
                          $refs.starttime.save(starttime)
                          showStartTimeDialog = false
                          changeDate('custom_time')
                        "
                        >{{ $t('Confirm') }}</v-btn
                      >
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm6>
              <span class="order_summary_datepicker" style="margin-bottom: 10px"
                >{{ $t('to') }}:</span
              >
              <v-layout wrap row>
                <v-flex xs8 class="form-control">
                  <datepicker
                    v-model="selectedDate.end"
                    style
                    @selected="onSelectedEndDate"
                  ></datepicker>
                </v-flex>
                <v-flex xs4 class="form-control">
                  <v-dialog
                    ref="endtime"
                    v-model="showEndTimeDialog"
                    :return-value.sync="endtime"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template #activator="{ on }">
                      <div class="pl-2 pr-2">
                        <input
                          v-model="endtime"
                          type="text"
                          readonly
                          placeholder="00:00"
                          v-on="on"
                        />
                      </div>
                    </template>
                    <v-time-picker v-if="showEndTimeDialog" v-model="endtime" full-width>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="showEndTimeDialog = false">
                        {{ $t('cancel') }}
                      </v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="
                          $refs.endtime.save(endtime)
                          showEndTimeDialog = false
                          changeDate('custom_time')
                        "
                        >{{ $t('Confirm') }}</v-btn
                      >
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>

        <v-divider class="mt-3 mb-3"></v-divider>

        <v-layout wrap>
          <v-flex xs12 sm8>
            <div
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'all'"
                :color="filterStatus != 'all' ? 'grey' : 'primary'"
                @click="changeStatus('all')"
                >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'ordered'"
                :color="filterStatus != 'ordered' ? 'grey' : 'primary'"
                @click="changeStatus('ordered')"
                >{{ $t('ordered') }} {{ badge.ordered > 0 ? '(' + badge.ordered + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'paid'"
                :color="filterStatus != 'paid' ? 'grey' : 'primary'"
                @click="changeStatus('paid')"
                >{{ $t('paid') }} {{ badge.paid > 0 ? '(' + badge.paid + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'shipped'"
                :color="filterStatus != 'shipped' ? 'grey' : 'primary'"
                @click="changeStatus('shipped')"
                >{{ $t('shipped') }} {{ badge.shipped > 0 ? '(' + badge.shipped + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'canceled'"
                :color="filterStatus != 'canceled' ? 'grey' : 'primary'"
                @click="changeStatus('canceled')"
              >
                {{ $t('cancel') }}
                {{ badge.canceled > 0 ? '(' + badge.canceled + ')' : '' }}
              </v-btn>
            </div>
          </v-flex>
          <v-flex xs12 sm4 class="text-xs-right">
            <print-all-covers
              :orders="filterOrders"
              :circle="false"
              style="display: inline-block"
              type="nvbbpreorder"
              @onPrinCover="onPrinCover(false, $event)"
            ></print-all-covers>
          </v-flex>
          <v-flex xs6 class="form-control">
            <DatepickerCustomDialog
              v-model="shipping_date"
              style="display: inline-block"
              @input="onchangeDate($event)"
            >
              <template #default="{ computedDate }">
                <input
                  name="shipping_date"
                  data-vv-as="Shipping Date"
                  :value="computedDate"
                  readonly
                  placeholder="DD/MM/YYYY"
                  style="display: inline-block"
                  type="text"
                />
              </template>
            </DatepickerCustomDialog>
            <v-btn fab small flat style="vertical-align: top" @click="shipping_date = null"
              ><v-icon>delete</v-icon></v-btn
            >
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <div class="text-xs-right">
              <v-layout style="display: inline-block">
                <v-btn
                  outline
                  color="grey"
                  class="mr-0"
                  style="border-right: 0; display: inline-block"
                  @click="exportOrderSummary"
                >
                  <em class="fas fa-file-export mr-1" />
                  {{ $t('export') }}
                </v-btn>
                <v-menu offset-y>
                  <template #activator="{ on }">
                    <v-btn
                      color="grey"
                      dark
                      style="display: inline-block; border-radius: 0; margin-left: -10px"
                      outline
                      icon
                      v-on="on"
                    >
                      <v-icon>arrow_drop_down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="exportOrderSummary('merge')">
                      <v-list-tile-title>{{ $t('Export old format') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="exportOrderSummary('kerry')">
                      <v-list-tile-title>{{ $t('Export kerry format') }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-layout>
              <v-btn
                v-tooltip.top="$t('Refresh')"
                fab
                outline
                color="primary"
                small
                @click="onRefresh"
              >
                <em class="fa fa-refresh" />
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <div>
          <v-layout wrap>
            <v-flex xs12 sm4 class="form-control px-1">
              <input v-model="search" type="text" :placeholder="$t('Search')" />
            </v-flex>

            <v-flex sm4 class="px-1">
              <multiselect
                v-if="shippingOptions.length"
                v-model="shippingFilter"
                label="name"
                :options="filteredShipping"
                :placeholder="$t('Shipping')"
                track-by="value"
                :multiple="true"
              >
                <template slot="option" slot-scope="props">
                  <span class="option__title"
                    >{{ $t(props.option.name) }} ({{ props.option.count }})</span
                  >
                </template>
              </multiselect>
            </v-flex>

            <v-flex xs12 sm4 class="text-xs-center text-sm-right">
              <v-pagination
                v-model="pageNumber"
                :length="pageCount"
                class="mb-2"
                @input="onClickPageinate"
              ></v-pagination>
            </v-flex>
          </v-layout>
          <div style>
            <template v-if="filterSummary.length > 0">
              <v-layout>
                <v-flex sm3>
                  <v-checkbox
                    id="cbAll"
                    v-model="checkboxAll"
                    :label="$t('Check all')"
                    style="display: inline-block; margin: 0"
                    color="primary"
                    @change="clickCbAll"
                  ></v-checkbox>
                </v-flex>
                <v-spacer />
                <v-flex text-xs-right style="padding-right: 1em"></v-flex>
                <v-flex sm4>
                  <multiselect
                    v-model="status"
                    label="label"
                    :disabled="!cbAll.length"
                    :options="orderStatusOptions"
                    :allow-empty="true"
                    :searchable="false"
                    :placeholder="$t('Modify all status')"
                    select-label
                    selected-label
                    deselect-label
                    @select="onSelectOrderStatus"
                  ></multiselect>
                </v-flex>
              </v-layout>
              <nvbb-summary-item
                v-for="(order, index) in filterSummary"
                :key="'order_' + order.id"
                v-model="filterSummary[index]"
                :cb-all.sync="cbAll"
                @assignCb="assignCb"
                @updateOrder="updateOrder(order.id, $event)"
                @onChangeStatus="onChangeStatus(order.id)"
              ></nvbb-summary-item>
              <div class="text-xs-right" style="padding-top: 10px">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  class="mb-2"
                  @input="onClickPageinate"
                ></v-pagination>
              </div>
            </template>
            <template v-else>
              <div class="text-xs-center" style="margin: 35px 0">
                <img
                  src="/static/img/assets/ecommerce/empty_shopping_cart.png"
                  alt
                  style="width: 230px"
                />
                <h3 class="headline">{{ $t('No data') }}</h3>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <div class="mb-5 mt-5"></div>
  </v-container>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'

import Editable from '@/components/elements/Editable'
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'
import NvbbSummaryItem from './NvbbSummaryItem'
import OrderSummaryMobile from './OrderSummaryMobile'
import ModalHelp from '@/components/elements/ModalHelp'
import Multiselect from 'vue-multiselect'
import PrintAllCovers from './PrintAllCovers.vue'
import XLSX from 'xlsx'
import ShopProfile from '@/components/view/setting/ecommerce/ShopProfile'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'

export default {
  components: {
    datepicker,
    Editable,
    NvbbSummaryItem,
    OrderSummaryMobile,
    ShopProfile,
    ModalHelp,
    Multiselect,
    PrintAllCovers,
    DatepickerCustomDialog
  },
  data: function () {
    return {
      loading: true,
      shippingFilter: [],
      shippingOptions: [],
      isEditShop: false,
      cbAll: [],
      checkboxAll: false,
      pageNumber: 1,
      size: 10,
      search: '',
      filterStatus: 'all',
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: '00:00',
      endtime: '23:59',
      selectedDate: {
        start: moment().toDate(),
        end: moment().toDate()
      },
      summary: [],
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      currentFilter: 'today',
      badge: {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      },
      status: '',
      orderStatusOptions: [
        {
          label: this.$t('ordered'),
          value: 'ordered'
        },
        {
          label: this.$t('paid'),
          value: 'paid'
        },
        {
          label: this.$t('shipped'),
          value: 'shipped'
        },
        {
          label: this.$t('cancel'),
          value: 'canceled'
        }
      ],
      shipping_date: null
    }
  },
  computed: {
    // cbAll() {
    //   return this.summary.filter(v=> {
    //     return v.cb
    //   }).map( v => v.id )
    // },
    filteredShipping() {
      let vm = this
      // console.log(vm.shippingOptions.map(el => {name: $t(el.name), value: el.name, count: vm.summary.filter( v => v.shippingtype == el.name).length}))
      return vm.shippingOptions.map((el) => {
        return {
          name: vm.$t(el.name),
          value: el.value,
          count: vm.summary.filter((v) => v.shippingtype == el.value).length
        }
      })
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile'
    }),
    pageCount: function () {
      let l = this.badge[this.filterStatus]
      let s = this.size
      return Math.ceil(l / s)
    },
    filterSummary: function () {
      let vm = this
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.summary
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.remark.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }

      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }

      if (vm.shipping_date) {
        filter = filter.filter((el) => {
          return (
            moment(el.shippingdate).format('YYYY-MM-DD') ==
            moment(vm.shipping_date).format('YYYY-MM-DD')
          )
        })
      }

      vm.badge = {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      }
      vm.badge.all = filter.length

      $.each(filter, function (index, val) {
        vm.badge[val.status] += 1
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })
      orders = orders.sort(function (a, b) {
        return new Date(b.timestamp) - new Date(a.timestamp)
      })
      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return orders.slice(start, end)
    },
    filterOrders: function () {
      let vm = this
      let orders = this.summary
      let filter = this.summary

      if (vm.search == '') {
        filter = vm.summary
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.remark.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }

      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }
      if (this.filterStatus !== 'all') {
        filter = filter.filter((el) => el.status == this.filterStatus)
      }

      if (vm.shipping_date) {
        filter = filter.filter((el) => {
          return (
            moment(el.shippingdate).format('YYYY-MM-DD') ==
            moment(vm.shipping_date).format('YYYY-MM-DD')
          )
        })
      }

      if (this.cbAll.length) {
        return filter.filter((el) => this.cbAll.includes(el.id))
      } else {
        return filter
      }
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.pageNumber = 1
        this.clearSelectAll()
      }
    }
  },
  mounted: async function () {
    this.loading = true
    let promiseOrderSummary = this.getOrderSummary()
    // let promiseShipping = this.getShipping()
    this.shippingOptions = [
      {
        value: 'drop',
        name: 'Drop point'
      },
      {
        value: 'hub',
        name: 'Hub'
      },
      {
        value: 'scg',
        name: 'SCG'
      },
      {
        value: 'interexpress',
        name: 'Inter express'
      }
    ]
    await promiseOrderSummary
    // await promiseShipping
    this.loading = false
    this.$store.dispatch('loadProducts')
    await this.$store.dispatch('loadPageProfile')
  },
  filters: {
    formatdate: function (value) {
      return moment(value).format('YYYY/MM/DD h:mm:ss a')
    }
  },
  methods: {
    async onPrinCover(allcontents, payload) {
      var orders = []
      if (allcontents) {
        var orders = await this.getOrderForExport()
      } else orders = this.filterOrders
      payload.printPdf(orders)
    },
    async getOrderForExport() {
      let vm = this
      var response = await this.getOrderSummary(true, true)
      var orders = []
      if (response.data) {
        orders = response.data
      }
      let filter = orders

      if (vm.search == '') {
        if (vm.filterStatus !== 'all') {
          filter = filter.filter((el) => el.status == vm.filterStatus)
        }
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            (el.first_name && el.first_name.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.last_name && el.last_name.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.id && el.id.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.productdetail &&
              el.productdetail.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.nameaddress && el.nameaddress.toLowerCase().includes(vm.search.toLowerCase()))
          )
        })
      }
      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }
      if (this.cbAll.length) {
        return filter.filter((el) => this.cbAll.includes(el.id))
      } else {
        return filter
      }
    },
    onchangeDate() {},
    async onRefresh() {
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    getShipping() {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = { pageid: vm.selectedBot.pageid }
        api.getAllShipingCharge(data, (error, response) => {
          if (error) reject(error)

          let result = Object.keys(response.shippinglist).map(function (key) {
            return { name: key, ...response.shippinglist[key] }
          })

          vm.shippingOptions = result
          vm.$store.state.shippinglist = response.shippinglist
          resolve()
        })
      })
    },
    assignCb(id) {
      if (this.cbAll.includes(id)) this.cbAll = this.cbAll.filter((v) => id != v)
      else {
        this.cbAll.push(id)
      }
    },
    clickCbAll() {
      if (!this.cbAll.length) {
        if (this.filterStatus !== 'all') {
          this.cbAll = this.summary.filter((el) => el.status === this.filterStatus).map((v) => v.id)
        } else {
          this.cbAll = this.summary.map((v) => v.id)
        }

        this.checkboxAll = true
      } else {
        this.cbAll = []
        this.checkboxAll = false
      }
    },
    onSelectOrderStatus(status) {
      let vm = this
      let data = {
        status: status.value,
        orderid: this.cbAll,
        pageid: this.selectedBot.pageid
      }
      vm.$store.dispatch('loading')
      api.putnvbb_multistatusordersummary(data, async function (error, response) {
        if (error) return console.error(error)
        var promiseStatus = []
        vm.summary.forEach(async (el) => {
          if (vm.cbAll.includes(el.id)) {
            if (vm.selectedBot.pageid != '1227843817265057') {
              if (status.value != 'canceled' && el.status == 'canceled') {
                promiseStatus.push(
                  new Promise((resolve) => {
                    let data = {
                      pageid: vm.selectedBot.pageid,
                      orderid: el.id,
                      type: 'DELETE'
                    }
                    api.nvbb_pre_order_stock_update(data).then(() => {
                      resolve()
                    })
                  })
                )
              } else if (el.status != 'canceled' && status.value == 'canceled') {
                promiseStatus.push(
                  new Promise((resolve) => {
                    let data = {
                      pageid: vm.selectedBot.pageid,
                      orderid: el.id,
                      type: 'ADD'
                    }
                    api.nvbb_pre_order_stock_update(data).then(() => {
                      resolve()
                    })
                  })
                )
              }
            }

            el.status = status.value
          }
        })
        await Promise.all(promiseStatus)
        vm.$store.dispatch('loading')
      })
    },
    onClickPageinate: function (pageNum) {
      $('.vb-content').animate({
        scrollTop: 0
      })
    },
    changeDate: function (value) {
      var vm = this
      vm.currentFilter = value
      //
      switch (value) {
        case 'today':
          vm.selectedDate.start = moment().toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_7_days':
          vm.selectedDate.start = moment().subtract(7, 'd').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_15_days':
          vm.selectedDate.start = moment().subtract(15, 'd').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_month':
          vm.selectedDate.start = moment().subtract(1, 'months').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'this_month':
          vm.selectedDate.start = moment().startOf('month').toDate()
          vm.selectedDate.end = moment().endOf('month').toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'this_year':
          vm.selectedDate.start = moment().startOf('year').toDate()
          vm.selectedDate.end = moment().endOf('year').toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'last_365_day':
          vm.selectedDate.start = moment().subtract(365, 'days').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.starttime = '00:00'
          vm.endtime = '23:59'
          vm.onSelectedDate()
          break

        case 'custom_date':
          break

        case 'custom_time':
          vm.onSelectedDate()
          break
      }
    },
    onSelectedDate: async function (value) {
      this.pageNumber = 1
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    onSelectedStartDate: async function (value) {
      this.pageNumber = 1
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    onSelectedEndDate: async function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
      this.loading = true
      await this.getOrderSummary()
      this.loading = false
    },
    changeStatus: function (value) {
      this.filterStatus = value
      this.pageNumber = 1
      this.clearSelectAll()
    },
    getOrderSummary: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          datefrom:
            moment(vm.selectedDate.start).format('YYYY-MM-DD') +
            (vm.starttime != null ? ' ' + vm.starttime : ''),
          dateto:
            moment(vm.selectedDate.end).format('YYYY-MM-DD') +
            (vm.endtime != null ? ' ' + vm.endtime : ''),
          status: vm.filterStatus,
          allcontents: false
        }
        // vm.$store.dispatch('loading')
        api.getNvbbOrderSummary(data, function (error, response) {
          if (error) {
            console.error(error)
            // vm.$store.dispatch('loading')
            reject()
            return
          }
          if (response.data) {
            try {
              vm.summary = response.data.map((el) => {
                let json = []
                if (el.jsonvalue) {
                  try {
                    json = JSON.parse(el.jsonvalue)
                  } catch (error) {}
                }
                return {
                  ...el,
                  jsonvalue: json
                }
              })
            } catch (error) {
              vm.summary = []
            }

            if (vm.filterStatus == 'all') {
              vm.badge = {
                all: response.all,
                canceled: response.canceled,
                ordered: response.ordered,
                paid: response.paid,
                shipped: response.shipped
              }
            }
          }
          vm.clearSelectAll()
          resolve()
          // vm.$store.dispatch('loading')
        })
      })
    },
    onChangeStatus: function (index) {
      let vm = this
      vm.updateOrder(index, 'save')
    },
    clearSelectAll() {
      this.cbAll = []
      this.checkboxAll = false
    },
    updateOrder: async function (id, payload, callback) {
      let vm = this
      vm.$store.dispatch('loading')
      if (!vm.summary) {
        return false
      }
      let data = vm.summary.find(function (element) {
        return element.id === id
      })

      if (payload == 'send' && data.status == 'canceled') {
        data.sendreason = true
      }
      if (data) {
        api.editNvbbOrderSummary(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            return
          }
          if (callback) {
            callback()
          }
          vm.$store.dispatch('loading')
        })
      }
    },
    exportOrderSummary: function (type) {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filter = this.filterOrders
      let filename = ''
      // if (vm.search == '') {
      //   filter = vm.summary
      // } else {
      //   filter = vm.summary.filter(function(el) {
      //     return (
      //       el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
      //       el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
      //       el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
      //       el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
      //       el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
      //     )
      //   })
      // }
      var json = []

      $.each(filter, function (index, val) {
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      if (type == 'merge') {
        orders = orders.sort(
          (a, b) => moment(a.timestamp).format('YYYYMMDD') - moment(b.timestamp).format('YYYYMMDD')
        )
        $.each(orders, function (index, val) {
          var productdetail = ''
          try {
            var products = JSON.parse(val.productdetail)
          } catch (error) {
            var products = val.productdetail
          }

          let total_quantiy = 0

          try {
            if (typeof products == 'object' && products.length > 0) {
              products.map(function (product) {
                productdetail +=
                  product.name +
                  ' x ' +
                  product.quantity +
                  ` SKU:${product.sku ? product.sku : '- '}` +
                  (product.option ? ' (' + product.option + ')' : '') +
                  ' : ' +
                  '\r\n'
              })
            } else {
              productdetail = val.productdetail
            }
          } catch (error) {
            productdetail = val.productdetail
          }

          var realname = val.nameaddress.split(' , ')
          var shippingType = ''
          try {
            var jsondata = JSON.parse(val.shippingtype)
            if (jsondata.type) {
              shippingType = jsondata.type
            }
          } catch (error) {
            shippingType = val.shippingtype
          }

          json.push({
            'Order No.': val.id,
            Products: productdetail,
            total: total_quantiy,
            Remark: val.remark,
            'Social Name': val.first_name + ' ' + val.last_name,
            'Real Name': realname.length > 1 ? realname[0] : '',
            Address: val.nameaddress,
            Price: numeral(val.amount).format('0,0.00').toString(),
            Shipping: shippingType ? vm.$t(shippingType) : '',
            'Shipping Date': val.shippingdate
              ? moment(val.shippingdate).format('DD/MM/YYYY HH:mm')
              : '',
            'Shipping Charge': val.shippingcharge,
            'Tracking No.': val.trackingno,
            'Created Date': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
            Status:
              vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
            Tags: vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
            SKU: products[0].sku ? `${products[0].sku}` : '-',
            Quantity: val.allquantity ? `${val.allquantity}` : '-'
          })
        })
        filename = 'zwizshop'
      } else if (type == 'kerry') {
        orders = orders.sort(
          (a, b) => moment(a.timestamp).format('YYYYMMDD') - moment(b.timestamp).format('YYYYMMDD')
        )
        $.each(orders, function (index, val) {
          var postcode = ''
          var phone = ''
          var name = ''
          var address = val.nameaddress.split(' , ')
          var result_address = ''

          var shippingType = ''
          try {
            var jsondata = JSON.parse(val.shippingtype)
            if (jsondata.type) {
              shippingType = jsondata.type
            }
          } catch (error) {
            shippingType = val.shippingtype
          }
          var price =
            shippingType == 'cod_charge' ? numeral(val.amount).format('0,0.00').toString() : 0
          if (address.length > 0) {
            name = address[0]
            address.splice(0, 1)
            phone = address[address.length - 1]
            address.splice(address.length - 1, 1)
            result_address = address.join('')
            var postcode_regex = /[0-9]{5}/g
            if (result_address.match(postcode_regex)) {
              var postcode_match = result_address.match(postcode_regex)
              if (postcode_match.length > 0) {
                postcode = postcode_match[0]
                result_address = result_address.replace(postcode, '')
              }
            }
          }

          json.push({
            No: index + 1,
            'Recipient Name': name,
            'Mobile No.': phone,
            Email: '',
            'Address #1': result_address,
            'Address #2': '',
            'Zip Code': postcode,
            'COD Amt (Baht)': price,
            Remark: val.remark
          })
        })
        filename = 'zwizshop_kerry'
      } else {
        // csvContent +=
        //   'Order No.,Status,SKU,Products,Price,Remark,Social Name,Real Name,Address,Price,Shipping,Tracking No.,Created Date,Status,Tags,Quantity' +
        //   '\r\n'
        orders = orders.sort(
          (a, b) => moment(a.timestamp).format('YYYYMMDD') - moment(b.timestamp).format('YYYYMMDD')
        )
        $.each(orders, function (index, val) {
          var productdetail = []
          try {
            var products = JSON.parse(val.productdetail)
          } catch (error) {
            var products = val.productdetail
          }
          let total_quantiy = 0
          // console.log('product', typeof products, products)
          try {
            if (typeof products == 'object' && products.length > 0) {
              products.map(function (product) {
                productdetail.push({
                  name: product.name ? product.name : '',
                  quantity: product.quantity,
                  sku: product.sku ? product.sku : '',
                  option: product.option ? ' (' + product.option + ')' : '',
                  price: product.price > 0 ? product.price : 'Free'
                })
              })

              total_quantiy = products.reduce((prev, curr) => {
                prev += parseInt(curr.quantity)
                return prev
              }, 0)
            } else {
              productdetail[0] = val.productdetail
            }
          } catch (error) {
            productdetail[0] = val.productdetail
          }
          // console.log(typeof productdetail, productdetail)

          var realname = val.nameaddress.split(' , ')
          var shippingType = ''
          try {
            var jsondata = JSON.parse(val.shippingtype)
            if (jsondata.type) {
              shippingType = jsondata.type
            }
          } catch (error) {
            shippingType = val.shippingtype
          }

          let shippingcharge = null
          if (val.order_json) {
            let json = null
            try {
              json = JSON.parse(val.order_json)
            } catch (error) {
              console.log(error)
            }
            shippingcharge =
              (json && json.totalFee ? parseInt(json.totalFee) : 0) +
              (json && json.shop_fee ? parseInt(json.shop_fee) : 0)
          }

          json.push({
            'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
            'Order Number': val.id,
            'Status Order': val.status,
            'Total per Order': val.allquantity || total_quantiy || '-',
            SKU: typeof productdetail[0] == 'string' ? products[0].sku : productdetail[0].sku,
            Products:
              typeof productdetail[0] == 'string'
                ? productdetail[0]
                : `${productdetail[0].name}${
                    productdetail[0].option ? ` ${productdetail[0].option}` : ''
                  }`,
            'SKU Amount':
              typeof productdetail[0] == 'string'
                ? productdetail[0].quantity
                : products[0].quantity,
            Price:
              typeof productdetail[0] == 'string'
                ? ''
                : numeral(productdetail[0].price).format('0,0.00'),
            Remark: val.remark != null ? val.remark : '',
            Channel: val.app,
            'Social Name': val.first_name + ' ' + val.last_name,
            'Real Name': realname.length > 1 ? realname[0] : '',
            Address: val.nameaddress,
            Total: numeral(val.amount).format('0,0.00').toString(),
            Shipping: shippingType ? vm.$t(shippingType) : '',
            'Shipping Date': val.shippingdate
              ? moment(val.shippingdate).format('DD/MM/YYYY HH:mm')
              : '',
            'Shipping Charge': numeral(shippingcharge || val.shippingcharge).format('0,0.00'),
            'Shipping Fee':
              val.order_json && JSON.parse(val.order_json)
                ? JSON.parse(val.order_json).shop_fee || 0
                : 0,
            'Tracking No.': val.trackingno,

            Status:
              vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
            'Customer Tags': vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-'
          })

          if (productdetail.length > 1) {
            productdetail.map((detail, dindex) => {
              if (dindex != 0) {
                json.push({
                  SKU: detail.sku,
                  Products: `${detail.name}${detail.option ? ` ${detail.option}` : ''}`,
                  Price: numeral(detail.price).format('0,0.00'),
                  'SKU Amount': detail.quantity
                })
              }
            })
          }
        })
        filename = 'zwizshop'
      }

      var dataWS = null
      if (type == 'kerry') dataWS = XLSX.utils.json_to_sheet(json, { origin: 'A8' })
      else dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/nvbb-order-summary.vue